import React from "react";
import {Modal, Button} from "react-bootstrap";
import {formatDataIt} from "../../../Utils/DateFormat";

const ModalChangePlanPreview = ({show, handleClose, handleConfirm, previewData, isLoading}) => {
    if (!previewData) return null;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Conferma cambio piano</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <p className="mb-1"><strong>Piano attuale:</strong> {previewData.current_plan}</p>
                    <p className="mb-1"><strong>Nuovo piano:</strong> {previewData.new_plan_name}</p>
                    <p className="mb-1"><strong>Prezzo nuovo piano:</strong> €{previewData.new_plan_price?.toFixed(2)}/anno</p>
                </div>

                {previewData.immediate && (
                    <div className="alert alert-info mb-3">
                        Il cambio sarà immediato
                    </div>
                )}

                {!previewData.immediate && (
                    <div className="alert alert-warning mb-3">
                        Il cambio sarà effettivo dal {previewData.effective_date ? formatDataIt(new Date(previewData.effective_date)) : '-'}
                    </div>
                )}

                {previewData.charge_now > 0 && (
                    <p className="mb-1">
                        <strong>Addebito immediato:</strong> <span className="text-danger fw-bold">€{previewData.charge_now?.toFixed(2)}</span>
                    </p>
                )}

                {previewData.has_trial && (
                    <div className="alert alert-info mb-3">
                        Include {previewData.trial_days} giorni di prova gratuita
                    </div>
                )}

                {previewData.next_charge_date && (
                    <p className="mb-1">
                        <strong>Prossimo addebito:</strong> €{previewData.next_charge_amount?.toFixed(2)} il {formatDataIt(new Date(previewData.next_charge_date))}
                    </p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button className="bg-danger border-0" onClick={handleClose} disabled={isLoading}>
                    Annulla
                </Button>
                <Button className="bkg-second border-0" onClick={handleConfirm} disabled={isLoading}>
                    {isLoading ? 'Elaborazione...' : 'Conferma cambio piano'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalChangePlanPreview;
